module.exports = __webpack_public_path__ + "static/media/team.d6dc996c.png";